/* eslint-disable react/no-array-index-key */
import { HeadingDesc, SubSectionHeading } from '../Headings';
import './articleSection.css';

function ArticleSection(props) {
  const { heading, desc, points } = props;
  return (
    <section className="articleSection">
      <div className="content">
        <SubSectionHeading text={heading} />
        <HeadingDesc text={desc} />
        <ul className="articleBullets">
          {points.map((point, index) => (
            //   TODO: replace this index with item id
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default ArticleSection;
